import { Box, Typography, useMediaQuery, useTheme } from '@mui/material'
import { DataGrid } from 'Components/LifeDataGrid'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import StarRatings from 'react-star-ratings'
import { makePutRequest } from 'utils/api'

import urls from 'utils/urls'

function ListOperations({ fetchOperations, operations, setSelectedRows, fetchOperations2 }) {
  let navigate = useNavigate()
  const [modifiedColumns, setModifiedColumns] = useState([])
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const [rows, setRows] = useState(20)
  const [page, setPage] = useState(0)
  const handleRowsChange = (newPageSize) => {
    setRows(newPageSize)
    let url = `&limit=${newPageSize}&offset=${page}`
    fetchOperations(url)
  }

  const handlePageChange = (newPage) => {
    setPage(newPage * rows)
    let url = `&limit=${rows}&offset=${newPage * rows}`
    fetchOperations(url)
  }
  const handleScroll = () => {
    const gridElement = document.querySelector('.MuiDataGrid-virtualScroller')
    const { scrollTop, scrollHeight, clientHeight } = gridElement
    // Marge de 50px : scrollTop est en sous-pixels, l'égalité stricte
    // n'était quasiment jamais atteinte et les pages suivantes ne chargeaient pas
    if (scrollTop + clientHeight >= scrollHeight - 50) {
      let url = `&limit=${rows}&offset=${operations.results.length}`
      if (operations.results.length !== operations.count) fetchOperations2(url)
    }
  }
  useEffect(() => {
    const gridElement = document.querySelector('.MuiDataGrid-virtualScroller')

    if (gridElement) {
      gridElement.addEventListener('scroll', handleScroll)
    }

    return () => {
      if (gridElement) {
        gridElement.removeEventListener('scroll', handleScroll)
      }
    }
  }, [operations])

  useEffect(() => {
    if (isMobile) {
      setModifiedColumns([
        {
          field: 'Nom',
          headerName: 'Nom',
          // width: 210,
          flex: 1,
          // valueGetter: (params) => `${params.row.Nom?.Nom || params.row.IBAN}`,
          renderCell: (params) => (
            <Box py={2} mt={1} whiteSpace={'nowrap'}>
              <Box fontWeight={600}>{params.row.Nom}</Box>
              <Box>
                <Box component={'span'}>Catégorie:</Box>{' '}
                <Box component={'span'} fontWeight={600}>
                  {params.row.Catégorie}
                </Box>
              </Box>
              <Box>
                <Box component={'span'}>Type de repas:</Box>{' '}
                <Box component={'span'} fontWeight={600}>
                  {params.row.TypeDeRepas}
                </Box>
              </Box>
              <Box>
                <Box component={'span'}>Type de plat:</Box>{' '}
                <Box component={'span'} fontWeight={600}>
                  {params.row.typeDePlat.Name}
                </Box>
              </Box>
              <Box>
                <Box component={'span'}>Saison:</Box>{' '}
                <Box component={'span'} fontWeight={600}>
                  {params.row.Season || ''}
                </Box>
              </Box>
              <Box>
                <Box component={'span'}>Type de cuisine:</Box>{' '}
                <Box component={'span'} fontWeight={600}>
                  {params.row.typeDeCuisine.Name}
                </Box>
              </Box>
              <Box>
                <Box component={'span'}>Nombre de planification:</Box>{' '}
                <Box component={'span'} fontWeight={600}>
                  {parseFloat(params.row.rotation_rate * 100).toFixed(2)} %
                </Box>
              </Box>
            </Box>
          ),
        },
        {
          headerName: 'Plats préférée',
          // width: 160,
          flex: 1,
          cellClassName: 'dtcell',
          renderCell: (params) => {
            return (
              <Box sx={{ '.star-container': { pr: '0 !important' } }}>
                <GoldStar recette={params.row} />
              </Box>
            )
          },
        },
      ])
    } else {
      setModifiedColumns(columns)
    }
  }, [isMobile])
  const columns = [
    {
      field: 'Nom',
      headerName: 'Nom',
      width: 220,
      renderCell: (params) => params.row.Nom,
    },
    {
      field: 'Categorie',
      headerName: 'Catégorie',
      width: 140,
      editable: true,
      valueGetter: (params) => `${params.row.categorie.Name}`,
    },
    {
      field: 'TypeDeRepas',
      headerName: 'Type de repas',
      width: 140,
      editable: true,
    },
    {
      field: 'typeDePlat',
      headerName: 'Type de plat',
      width: 140,
      editable: true,
      valueGetter: (params) => `${params.row.typeDePlat.Name}`,
    },
    {
      field: 'Season',
      headerName: 'Saison',
      width: 140,
      editable: true,
      valueGetter: (params) => `${params.row.Season || ''}`,
    },
    {
      field: 'typeDeCuisine',
      headerName: 'Type de cuisine',
      width: 140,
      editable: true,
      valueGetter: (params) => `${params.row.typeDeCuisine.Name}`,
    },
    {
      field: 'PlatsPreferee',
      headerName: 'Plats préférée',
      width: 200,
      editable: true,
      renderCell: (params) => {
        return <GoldStar recette={params.row} />
      },
    },
    {
      field: 'rotation_rate',
      headerName: 'Nombre de planification',
      width: 160,
      editable: true,
      valueGetter: (params) => `${parseFloat(params.row.rotation_rate * 100).toFixed(2)} %`,
    },
  ]

  const GoldStar = ({ recette }) => {
    const [ratings, setRatings] = useState(recette.PlatsPreferee)
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
    const changeRating = (e) => {
      setRatings(e)
      const formData = new FormData()
      const payload = {
        id: recette.id,
        Nom: recette.Nom,
        PlatsPreferee: e,
      }
      for (const key in payload) {
        formData.append(`${key}`, `${payload[key]}`)
      }
      makePutRequest(
        urls.crudRecettesOperations + `${payload.id}/`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        },
        true,
      )
    }

    return (
      <StarRatings
        rating={ratings}
        starRatedColor="gold"
        starHoverColor="gold"
        changeRating={changeRating}
        numberOfStars={5}
        starDimension="18px"
        name="rating"
      />
    )
  }

  return (
    <div
      style={{
        width: '100% ',
        background: 'white',
        borderRadius: '5px',
      }}
    >
      <Typography
        variant="h6"
        sx={{
          flex: '1 1 100%',
          id: 'tableTitle',
          fontWeight: 600,
          padding: '10px',
          component: 'div',
        }}
      >
        Mes recettes de cuisine ({operations.count})
      </Typography>

      <DataGrid
        sx={{
          height: 680,
          fontSize: isMobile ? '11px' : '13px',
          '.dtcell': { alignItems: 'flex-start' },
          '.MuiDataGrid-footerContainer': { background: 'aliceblue' },
          '.MuiTablePagination-toolbar': { alignItems: 'baseline' },
        }}
        rows={operations.results ? operations.results : []}
        columns={modifiedColumns}
        pageSize={rows}
        getRowHeight={() => (isMobile ? 'auto' : 50)}
        rowCount={operations.count ? operations.count : 0}
        onPageSizeChange={handleRowsChange}
        onPageChange={handlePageChange}
        rowsPerPageOptions={[10, 20, 40, 80, 100]}
        pagination
        hideFooter
        onSelectionModelChange={(itm) => setSelectedRows([...itm])}
        paginationMode="server"
        checkboxSelection
        disableSelectionOnClick
        onRowClick={(params, event) => {
          if (event.target.localName === 'div') {
            if (event.target.classList.contains('star')) {
            } else {
              navigate(`/recette/${params.row.id}`)
            }
          }
        }}
      />
    </div>
  )
}
export default ListOperations
